export default __webpack_public_path__ + "static/media/elf-04.625e5ecd.jpg";